/**
 * Theme Name: project-sscms v1.516.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 034ad85e5]
 * Version: 1.516.0-2025-07-31T18-35-42
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File homepage-track.js.
 * Handles sending Segment events for homepage links 
 */

if (typeof jQuery !== 'undefined') jQuery(document).ready( function($) {

  function homeLinkTrack(e) {
    if (e.target) {
      // get the type of target
      const isEnterEnrollmentCta = (e.target.href && e.target.href.match( /(member\.chime|test\.1debit)\.com\/(signup|enroll)/ ) || e.target.matches('.email-capture-submit'));
      const isHomeNavItem = (e.target.matches('#header .menu-item a') && !e.target.matches('.apply a')) || e.target.matches('.header__nav-btn--open');
      
      // get link data
      const linkParent = $(e.target).parents('.sub-menu');
      const linkLabel = (isHomeNavItem && linkParent.length) ? linkParent.siblings('a').text() : 
                        e.target.matches('.header__nav-btn--open') ? 'menu' : 
                        e.target.textContent;
      const linkDestination = e.target.href;

      if (e.target.href && !isHomeNavItem && !isEnterEnrollmentCta) {
        // find button location as hero, bottom, or communication based on button parents
        const btnLocation = $(e.target).parents('.hero, .referral, .landing-page').length ? 'hero' : 
                            $(e.target).parents('.footer').length ? 'bottom' : 
                            'communication';

        const properties = {
          label: linkLabel,
          destination: linkDestination,
          button_location: btnLocation,
        };

        // fire Segment event: Homepage CTA Tapped
        segment(
          'track',
          'Homepage CTA Tapped',
          properties
        );
      }
    }
  }

  // add click listener for homepage clicks
  const page = document.getElementById('page');
  if (page !== null) {
    document.addEventListener( 'click', homeLinkTrack);
  }
});
